import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"

const Container = styled.div`
  transform: rotate(270deg);
  transform-origin: left top 0;
  position: absolute;
  width: ${props => props.boxHeight * 3}px;
  margin-left: -80px;
  ${props => (props.isSmall9BG ? "margin-top: -5px !important" : "margin-top: -10px !important")};
`
const LowBannerItem = styled.div`
  text-align: center;
  display: inline-block;
  margin-top: 15px;
  ${props => (props.isSmall9BG ? "padding-left: 0px !important" : "padding-left: 0px !important")};
  ${props =>
    (props.isSmall9BG ? "padding-right: 9px !important" : "padding-right: 25px !important")};
`
const MediumBannerItem = styled.div`
  text-align: center;
  display: inline-block;
  margin-top: 15px;
  ${props => (props.isSmall9BG ? "padding-left: 1px !important" : "margin-left: -20px !important")};
  ${props =>
    (props.isSmall9BG ? "padding-right: 8px !important" : "padding-right: 10px !important")};
`
const HighBannerItem = styled.div`
  text-align: center;
  display: inline-block;
  margin-top: 15px;
  ${props => (props.isSmall9BG ? "padding-left: 2px !important" : "padding-left: 10px !important")};
  ${props => (props.isSmall9BG ? "padding-right: 7px !important" : "")};
`
const BannerItemText = styled.div`
  text-align: center;
  border: 1px darkgrey solid;
  background: darkgray;
  color: white;
  font-weight: bold;
`

function PotentialBanner({ t, isSmall9BG, boxesHaveComparison }) {
  let boxHeight = boxesHaveComparison ? 175 : 150

  // If its the small 9BG then the comparison will never be on and it needs to be smaller.
  if (isSmall9BG) {
    boxHeight = 91
  }

  return (
    <Container
      id="ninebg-potential-axis"
      className={
        isSmall9BG
          ? "hidden-sm-down ninebg-potential-axis-small"
          : "hidden-sm-down ninebg-potential-axis-large"
      }
      boxHeight={boxHeight}
      isSmall9BG={isSmall9BG}
    >
      <div
        className="col-lg-12 col-md-12"
        style={{
 textAlign: "center", paddingBottom: "0", paddingLeft: "0", paddingRight: "0",
}}
      >
        <span style={{ color: "black" }}>{t("Common.Potential.Title")}</span>
      </div>
      <LowBannerItem className="col-lg-4 col-md-4" isSmall9BG={isSmall9BG}>
        <BannerItemText isSmall9BG={isSmall9BG}>{t("Common.Low")}</BannerItemText>
      </LowBannerItem>
      <MediumBannerItem className="col-lg-4 col-md-4" isSmall9BG={isSmall9BG}>
        <BannerItemText isSmall9BG={isSmall9BG}>{t("Common.Medium")}</BannerItemText>
      </MediumBannerItem>
      <HighBannerItem className="col-lg-4 col-md-4" isSmall9BG={isSmall9BG}>
        <BannerItemText isSmall9BG={isSmall9BG}>{t("Common.High")}</BannerItemText>
      </HighBannerItem>
    </Container>
  )
}

PotentialBanner.propTypes = {
  isSmall9BG: PropTypes.bool,
  boxesHaveComparison: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

PotentialBanner.defaultProps = {
  isSmall9BG: false,
  boxesHaveComparison: false,
}

export default translate()(PotentialBanner)



// WEBPACK FOOTER //
// ./src/components/charts/nine-box-grid/PotentialBanner.jsx